import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class ReviRemainingElementsResponseSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    booking_lead_time: { embedded: 'always' },
    company: { embedded: 'always' },
    rate_code: { embedded: 'always' },
    room_type: { embedded: 'always' },
    travel_agent: { embedded: 'always' },
    segment: { embedded: 'always' },
    los: { embedded: 'always' },
    weekday: { embedded: 'always' },
    guest_country: { embedded: 'always' },
    source_profile: { embedded: 'always' },
    origin: { embedded: 'always' },
    source: { embedded: 'always' },
  };
}
